import { useSearch } from '@tanstack/react-router';

import { useWorkMode } from 'shared/utils/useWorkMode';

import { useCurrentPageIndex } from './useCurrentPageIndex';
import { usePages } from './usePages';
import { HIDDEN_PAGE_PREFIX } from '../consts/hiddenPagePrefix';

export function useCurrentPageId() {
  const pageIndex = useCurrentPageIndex();
  const { pagesData, visiblePages, hiddenPages } = usePages();
  const { isStudioEdit } = useWorkMode();
  const searchParams = useSearch({ strict: false });
  const pageId = searchParams.pageId;

  if (isStudioEdit) {
    const pageExists = pagesData.some(({ id }) => id === pageId);
    if (!pageExists) {
      return null;
    }
    return pageId ?? pagesData[0]?.id ?? null;
  }
  const pageIndexStr = String(pageIndex);
  const page = pageIndexStr.startsWith(HIDDEN_PAGE_PREFIX)
    ? hiddenPages[Number(pageIndexStr.split(HIDDEN_PAGE_PREFIX)[1]) - 1]
    : visiblePages[Number(pageIndexStr) - 1];

  return page?.id ?? null;
}
